import React, { Component } from 'react';
import _ from 'underscore';
import ConservedDomainsHitsOverview from './conserved_domains_hits_overview';
import ConservedDomainsHitsTable from './conserved_domains_hits_table';
import CollapsePreferences from '../../sequenceserver/public/js/collapse_preferences';

export default class ConservedDomains extends Component {
    constructor() {
        super();
        this.name = 'Conserved Domains';
        this.collapsePreferences = new CollapsePreferences(this);
        let isCollapsed = this.collapsePreferences.preferenceStoredAsCollapsed();
        this.state = { collapsed: isCollapsed };
    }
    render() {
        const { report } = this.props.conservedDomains;
        const queryId = report ? report.results.search.query_id : 'loading-' + this.props.query.id;

        return (
            <div className='section-content conserved-domains-section' data-query-len={this.props.query.length} data-algorithm={this.props.program} id={queryId + '_cd'}>
                <h4 className="caption text-sm" onClick={() => this.collapsePreferences.toggleCollapse()}>
                    {this.collapsePreferences.renderCollapseIcon()}
                    <span> {this.name}</span>
                </h4>

                {!this.state.collapsed && this.renderInner(report, queryId)}
            </div>
        );
    }

    renderInner(report, queryId) {
        if (report === undefined) {
            return this.renderInnerLoading(queryId);
        } else if (report.results.search.hits.length === 0) {
            return <div className="hit empty-hit" id={queryId + '_CD_data'}>
                       <i>No Conserved Domains hits found for this sequence</i>
                   </div>
        } else {
            return this.renderInnerResults(report, queryId);
        }
    }

    renderInnerResults(report, queryId) {
        return <div id={queryId + '_CD_data'}>
                   <ConservedDomainsHitsOverview key={'CD_GO_' + queryId} queryId={queryId} hits={report.results.search.hits}/>
                   <ConservedDomainsHitsTable key={'CD_Table_' + queryId} queryId={queryId} hits={report.results.search.hits}/>
               </div>
    }

    renderInnerLoading(queryId) {
        return <div className="hit loading-hit" id={queryId + '_CD_data'}>
                   <i className="fa fa-cog fa-spin"></i>
                   <i>&nbsp;Looking up Conserved Domains, this may take a bit...</i>
               </div>
    }
}
